import { Button, LoadingOverlay, Select, Switch } from "@mantine/core";
import CloseIcon from '@mui/icons-material/Close';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import TextField from '@mui/material/TextField';
import * as React from 'react';
import { forwardRef, useEffect, useImperativeHandle, useState } from "react";
import { EnvironmentRegistry } from '../../services/registry/environmentRegistry';
import { CloneReportInfoRequestBody, commonPostReportInfo, ReportInfoRequestBody } from '../../services/reportService';
import { popNotification } from '../report/ReportCreationFormPages/FinalPreviewPage-VI/FinalPreviewPage';
import "./manageReport.css";
import { TranslationEnum, usePortalTranslation } from "../../providers/TranslationProvider";
import { ChannelkartNetworkPost } from "../../services/networkService";

interface ManageReportProps {
    rows: any[];
    setRows: (newRows: any[]) => void;
    originalRows: any[];
    setOriginalRows: (rows: any[]) => void;
    setIsCheckboxVisible: React.Dispatch<React.SetStateAction<boolean>>;
    selectedData: any[];
}
export const ReportTransfer = forwardRef((props: ManageReportProps, ref) => {
    const { translate } = usePortalTranslation();
    const CUR_COMPONENT_COMMON="commonPortal";
    const [lobs, setLobs] = useState<string[]>([]);
    const [env, setEnv] = useState<string | null>("DEV");
    const [lob, setLob] = useState<string | null>(null);

    const [existingReportCheck, setExistingReportCheck] = useState<boolean | null>(false);
    const [existingQueryCheck, setExistingQueryCheck] = useState<boolean | null>(false);

    const [isSuccess, setIsSuccess] = useState(false);
    const [isNewLobReports, setIsNewLobReports] = useState(false);
    const [showLoader, setShowLoader] = useState<boolean>(false);
    const [newReportName, setNewReportName] = useState<string>("");
    const [newQueryName, setNewQueryName] = useState<string>("");

    const defaultRequestBody = {
        sourceEnvironment: "",
        sourceLob: ""
    }
    const [cloneRequestBody, setCloneRequestBody] = useState<CloneReportInfoRequestBody | ReportInfoRequestBody>(defaultRequestBody);


    const authContext = localStorage.getItem("authContext") && JSON.parse(localStorage.getItem("authContext") as string);
    useEffect(() => {
        setLob(null);

        const fetchLobs = async () => {
            if (env != null) {
                const currentLobs = await EnvironmentRegistry.getLobs(env);
                setLobs(currentLobs);
            } else {
                setLobs([])
            }
        }
        fetchLobs()
            .catch(e => {
                console.log("something went wrong", e);
                setLobs([])
            })
    }, [env]);

    const [showOptions, setShowOptions] = useState(false);
    const [showEnvOptions, setShowEnvOptions] = useState(false);
    const [isOn, setIsOn] = useState(false);
    const envOptions: string[] = ['DEV', 'UAT', 'PROD', 'DEMO', "LOCAL"]



    const handleToggle = (value: boolean) => {
        if(!value && isNewLobReports){
            const currLob = localStorage.getItem("lob") || "";
            const currEnv = localStorage.getItem("env")?.toUpperCase() || "";
            applyRequest(currLob, currEnv);
        }
        setIsOn(value);
        setShowEnvOptions(!showOptions);
        props.setIsCheckboxVisible(value);
        setIsNewLobReports(false);
    };


    async function applyRequest(lob:string, env:string) {
        if (env == null || env === "") {
            popNotification("Missing Information", "Please choose the environment", "red");
            return;
        }
        if (lob == null || lob === "") {
            popNotification("Missing Information", "Please select the source LOB", "red")
            return;
        }
        try {
            const requestBody: ReportInfoRequestBody = {
                sourceEnvironment: env,
                sourceLob: lob
            }
            setShowLoader(true);
            const response = await ChannelkartNetworkPost('/v1/report/fetchEnvWiseReport', requestBody);
            if (response.status === 200) {
                setShowLoader(false);
                props.setOriginalRows(response.data)
                props.setRows(response.data);
                setIsNewLobReports(true);
            } else {
                setShowLoader(false)
                alert("something went wrong")
            }
        } catch (error) {
            console.log(error)
            setShowLoader(false)
            popNotification("Something went wrong", "Something went wrong please try later", 'red')
        }
    }

    useImperativeHandle(ref, () => ({
        cloneReport: cloneReport
    }));


    async function cloneReport(datarow: any) {
        if (env == null) {
            popNotification("Missing Information", "Please choose the environment", "red");
            return;
        }
        if (lob == null) {
            popNotification("Missing Information", "Please select the source LOB", "red")
            return;
        }
        setShowLoader(true)
        checkForExistingReport(datarow)
        setShowLoader(false)



    }

    async function checkForExistingReport(data: any) {
        try {
            const SourceQueryName = data ? data.queryName : '';
            const SourceReportinfoName = data ? data.name : '';
            const duplicacycheckrequestBody: CloneReportInfoRequestBody = {
                newQueryName: SourceQueryName,
                newReportName: SourceReportinfoName
            }
            const duplicateCheckResponse = await ChannelkartNetworkPost('/v1/report/findDuplicateReportInfoDetailsByID', duplicacycheckrequestBody);
            const duplicateReportNameVal = duplicateCheckResponse?.data?.newReportName ?? '';
            const duplicateQueryNameVal = duplicateCheckResponse?.data?.newQueryName ?? '';
            
            if (duplicateReportNameVal) {
                setExistingReportCheck(true);
              } else if (duplicateQueryNameVal.trim() !== '') {
                setExistingQueryCheck(true);
              }

            const requestBody: CloneReportInfoRequestBody = {
                sourceEnvironment: env as string,
                sourceLob: lob as string,
                idList: [data.id]
            }
            setCloneRequestBody(requestBody)
            if (!duplicateReportNameVal) {
                submitReport(requestBody)
            }

        } catch (error) {
            console.log(error)
            popNotification("Something went wrong", "Something went wrong please try later", 'red')
        }
    }

    useEffect(() => {
        if (!newReportName && isOn) {
            popNotification("Alert", "Please Enter Report Name", 'red')
        }
        setCloneRequestBody(pervCloneRequestBody => ({ ...pervCloneRequestBody, "newReportName": newReportName }));
    }, [newReportName]);

    useEffect(() => {
        if (!existingQueryCheck && isOn) {
            popNotification("Alert", "Please Enter Query Name", 'red')
        }
        setCloneRequestBody(pervCloneRequestBody => ({ ...pervCloneRequestBody, "newQueryName": newQueryName }));
    }, [newQueryName]);
    useEffect(() => {
        if (isSuccess) {
            setTimeout(() => {
                window.location.href = "/dashboard/manageReport";
            }, 2000);
        }
    }, [isSuccess]);
    async function submitReport(requestBody: CloneReportInfoRequestBody) {
        try {
            setShowLoader(true)
            let token = localStorage.getItem("token");
            let header = {};
            if(token){
                header = {internal_token: token};
            }
            const response = await ChannelkartNetworkPost('/v1/report/cloneReportById', requestBody, header);
            setShowLoader(false)
            if (response.status === 200) {
                setExistingReportCheck(false);
                setIsSuccess(true)
                popNotification("Sucess", "Your Report Submitted Sucessfully", 'green')
            } else {
                setShowLoader(false)
                popNotification("Something went wrong", "Something went wrong please try later", 'red')
            }
        } catch (error) {
            setShowLoader(false)
            console.log(error)
            popNotification("Something went wrong", "Something went wrong please try later", 'red')
        }
    }

    async function handleReportRename() {
        const clonerequestBody: CloneReportInfoRequestBody = {
            sourceEnvironment: authContext.env,
            sourceLob: authContext.lob,
            idList: props.selectedData.map((data: any) => data.id)

        }
    };

    const addnewReportName = (event: {
        target: { value: React.SetStateAction<string> };
    }
    ) => {
        setNewReportName(event.target.value);

    };

    const addnewQueryName = (event: {
        target: { value: React.SetStateAction<string> };
    }
    ) => {
        setNewQueryName(event.target.value);

    };

    const handleClose = () => {
        setExistingReportCheck(false);
    };




    return (
        <div className={"report-transfer-buttons"}>
            <div>
                <Switch
                    checked={isOn}
                    onChange={(event) => handleToggle(event.target.checked)}
                    label="Report Transfer"
                    color="teal"
                    style={{marginTop:"42px", width:"157px"}}
                />
            </div>
            <div>
                {showEnvOptions && isOn && (
                    <Select
                        label="Choose Source Env"
                        placeholder="Pick one"
                        searchable
                        nothingFound={translate(TranslationEnum.common_portal,"No options")}
                        onChange={setEnv}
                        value={env}
                        data={envOptions}
                    />
                )}
            </div>
            <div>
                {env && isOn && (
                    <Select
                        label="Choose Source LOB"
                        placeholder="Pick one"
                        searchable
                        nothingFound={translate(TranslationEnum.common_portal,"No options")}
                        value={lob}
                        onChange={setLob}
                        data={lobs}
                    />
                )}
            </div>
            {env && isOn && (
                <Button onClick={() => applyRequest(lob|| "", env)} color='teal' style={{ marginTop: "28px" }}> Apply </Button>
            )}
            {/* {env &s& isOn && (
                                     <Button onClick={() => cloneReport()} color='teal'> Clone </Button>
                                 )} */}

            {/* Loader */}

            {showLoader && (
                <LoadingOverlay
                    loaderProps={{ size: 'sm', color: 'teal', variant: 'bars' }}
                    visible={showLoader}
                    style={{ position: "fixed" }}
                />
            )}
            {/* Modal Report*/}
            <Dialog open={existingReportCheck ? true : false} onClose={handleClose}>
                <DialogTitle>Oops!! please rename Report Name</DialogTitle>
                <CloseIcon sx={{
                    position: 'absolute',
                    right: 8,
                    top: 8,
                    color: (theme) => theme.palette.grey[500],
                }} onClick={handleClose} />
                <DialogContent>
                    <DialogContentText>
                        Report already exist in logged in lob of current environment,
                        Please Rename Report and clone !!
                    </DialogContentText>
                    <TextField
                        autoFocus
                        margin="dense"
                        id="name"
                        // value={props.selectedData.map((data: any) => data.name)=== null ? "" :props.selectedData.map((data: any) => data.name)}
                        placeholder="Report Name"
                        type="text"
                        fullWidth
                        variant="standard"
                        onChange={addnewReportName}
                    />
                </DialogContent>
                <DialogActions>
                    {/* <Button color= "teal" onClick={handleReportOveriding}>Override</Button> */}
                    <Button color="teal" onClick={()=>submitReport(cloneRequestBody)}>Submit</Button>
                </DialogActions>
            </Dialog>
            {/* Modal Query*/}
            <Dialog open={existingQueryCheck ? true : false} onClose={handleClose}>
                <DialogTitle>Please Rename Query !!</DialogTitle>
                <CloseIcon sx={{
                    position: 'absolute',
                    right: 8,
                    top: 8,
                    color: (theme) => theme.palette.grey[500],
                }} onClick={handleClose} />
                <DialogContent>
                    <DialogContentText>
                        Query already exist in logged in lob of current environment,
                        Please Rename Query and clone !!
                    </DialogContentText>
                    <TextField
                        autoFocus
                        margin="dense"
                        id="name"
                        placeholder="Query   Name"
                        type="text"
                        fullWidth
                        variant="standard"
                        onChange={addnewQueryName}
                    />
                </DialogContent>
                <DialogActions>
                    {/* <Button color= "teal" onClick={handleReportOveriding}>Override</Button> */}
                    <Button color="teal" onClick={()=>submitReport(cloneRequestBody)}>Submit</Button>
                </DialogActions>
            </Dialog>
        </div>
    )

}



)
